var map = {
	"./a-ending hokjønn.mp3": 152,
	"./a-ending inkjekjønn.mp3": 153,
	"./a-infinitiv.mp3": 154,
	"./adn-ending.mp3": 155,
	"./ane-ending.mp3": 156,
	"./ao-lyd.mp3": 157,
	"./dl.mp3": 158,
	"./dn.mp3": 159,
	"./e-infinitiv.mp3": 160,
	"./edn-ending.mp3": 161,
	"./ene-ending.mp3": 162,
	"./i-ending hokjønn.mp3": 163,
	"./i-ending inkjekjønn.mp3": 164,
	"./inf_01og02.mp3": 165,
	"./inf_01pog02p.mp3": 166,
	"./inf_03og04.mp3": 167,
	"./inf_03pog30p.mp3": 168,
	"./inf_05og06.mp3": 169,
	"./inf_05pog06p.mp3": 170,
	"./inf_07og08.mp3": 171,
	"./inf_09og10.mp3": 172,
	"./inf_100og101.mp3": 173,
	"./inf_11og12.mp3": 174,
	"./inf_11pog12p.mp3": 175,
	"./inf_13og14.mp3": 176,
	"./inf_14pog29p.mp3": 177,
	"./inf_15og16.mp3": 178,
	"./inf_15pog16p.mp3": 179,
	"./inf_17og18.mp3": 180,
	"./inf_19og20.mp3": 181,
	"./inf_19pog60p.mp3": 182,
	"./inf_21og22.mp3": 183,
	"./inf_21pog26p.mp3": 184,
	"./inf_23og24.mp3": 185,
	"./inf_23pog24p.mp3": 186,
	"./inf_25og26.mp3": 187,
	"./inf_27og28.mp3": 188,
	"./inf_27pog28p.mp3": 189,
	"./inf_29og30.mp3": 190,
	"./inf_31og32.mp3": 191,
	"./inf_31pog32p.mp3": 192,
	"./inf_33og34.mp3": 193,
	"./inf_35og58.mp3": 194,
	"./inf_36og47.mp3": 195,
	"./inf_36pog48p.mp3": 196,
	"./inf_37og38.mp3": 197,
	"./inf_39og48.mp3": 198,
	"./inf_40og52.mp3": 199,
	"./inf_41og42.mp3": 200,
	"./inf_42pog54p.mp3": 201,
	"./inf_43og55.mp3": 202,
	"./inf_44og65.mp3": 203,
	"./inf_44pog55p.mp3": 204,
	"./inf_45og46.mp3": 205,
	"./inf_46pog61p.mp3": 206,
	"./inf_49og61.mp3": 207,
	"./inf_50og62.mp3": 208,
	"./inf_51og60.mp3": 209,
	"./inf_51pog59p.mp3": 210,
	"./inf_52pog53p.mp3": 211,
	"./inf_53og63.mp3": 212,
	"./inf_54og64.mp3": 213,
	"./inf_56og66.mp3": 214,
	"./inf_57og67.mp3": 215,
	"./inf_59.mp3": 216,
	"./inf_68og69.mp3": 217,
	"./inf_70og71.mp3": 218,
	"./inf_72og73.mp3": 219,
	"./inf_74og75.mp3": 220,
	"./inf_76og77.mp3": 221,
	"./inf_78og79.mp3": 222,
	"./inf_80og81.mp3": 223,
	"./inf_82og83.mp3": 224,
	"./inf_84og85.mp3": 225,
	"./inf_86og87.mp3": 226,
	"./inf_88og89.mp3": 227,
	"./inf_90og91.mp3": 228,
	"./inf_92og93.mp3": 229,
	"./inf_94og95.mp3": 230,
	"./inf_96og97.mp3": 231,
	"./inf_98og99.mp3": 232,
	"./ll.mp3": 233,
	"./rn.mp3": 234,
	"./å-lyd.mp3": 235
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 98;